import { any, equals, includes, pick } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { replaceData } from '@gef-ui/form-core/stream/transfer/control';

import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { setSelectedClient } from 'features/views/taskCreatingPages/slice';

import { dialogs, searchErrorMsgs } from './constants';
import { CLIENT_SEARCH_FORM_NAME, FIELDS } from './form';
import { setClients } from './slice';
import { checkAllowedSearchCombinations, requestFactory } from './utils';

export const searchClients =
	() =>
	async (dispatch, getState, { getFormData }) => {
		dispatch(dialog.actions.clear());

		const formData = await getFormData(CLIENT_SEARCH_FORM_NAME);
		// validate form data combinations
		if (!checkAllowedSearchCombinations(formData)) {
			return dispatch(dialog.actions.open(dialogs.requiredFields, null, dialog.constants.ERROR));
		}

		dispatch(
			fetch.actions.post(fetch.constants.urls.partnerList, {
				takeLatest: true,
				body: requestFactory(formData),
				queryParams: { maxLength: 51 },
				onSuccess: [
					(response) => () => {
						response?.body && dispatch(setClients(response?.body));
					},
				],
				onError: [
					({ failure }) =>
						() => {
							const invalidPersonInBeforeYear1954 = includes(
								searchErrorMsgs.invalidPersonInBeforeYear1954,
								failure?.parsedContent?.message,
							);

							const invalidPersonInModulo = includes(
								searchErrorMsgs.invalidPersonInModulo,
								failure?.parsedContent?.message,
							);

							const invalidPersonInNotMatchingGivenBirthDate = includes(
								searchErrorMsgs.invalidPersonInNotMatchingGivenBirthDate,
								failure?.parsedContent?.message,
							);

							const invalidPersonInErrorCases = [invalidPersonInBeforeYear1954, invalidPersonInModulo];

							if (any(equals(true))(invalidPersonInErrorCases)) {
								dispatch(dialog.actions.open(dialogs.invalidPersonIn, null, dialog.constants.ERROR));
							}

							if (invalidPersonInNotMatchingGivenBirthDate) {
								dispatch(
									dialog.actions.open(
										dialogs.invalidPersonInNotMatchingGivenBirthDate,
										null,
										dialog.constants.ERROR,
									),
								);
							}
						},
				],
				shouldReportError: ({ failure }) => {
					if (failure?.status === 500) {
						const invalidPersonInBeforeYear1954 = includes(
							searchErrorMsgs.invalidPersonInBeforeYear1954,
							failure?.parsedContent?.message,
						);

						const invalidPersonInModulo = includes(
							searchErrorMsgs.invalidPersonInModulo,
							failure?.parsedContent?.message,
						);
						const invalidPersonInNotMatchingGivenBirthDate = includes(
							searchErrorMsgs.invalidPersonInNotMatchingGivenBirthDate,
							failure?.parsedContent?.message,
						);

						const allErrorCases = [
							invalidPersonInBeforeYear1954,
							invalidPersonInModulo,
							invalidPersonInNotMatchingGivenBirthDate,
						];

						if (any(equals(true))(allErrorCases)) {
							return false;
						} else {
							return true;
						}
					} else {
						return true;
					}
				},
			}),
		);
	};

export const fetchClientById = (id, queryParams) => (dispatch) => {
	return dispatch(
		fetch.actions.get(fetch.constants.urls.partner, {
			replaceParams: { id },
			queryParams,
			onSuccess: [
				(response) => () => {
					response?.body && dispatch(setSelectedClient(response?.body));
					return response?.body;
				},
			],
		}),
	);
};

export const prefillFormDataFromMainFilter =
	(formData) =>
	(dispatch, getState, { sendControlNext }) => {
		const relevantFields = pick([
			FIELDS.surname,
			FIELDS.firstName,
			FIELDS.personIn,
			FIELDS.birthDate,
			FIELDS.businessName,
			FIELDS.businessIn,
			FIELDS.street,
			FIELDS.streetNo,
			FIELDS.municipality,
			FIELDS.zipCode,
		])(formData);

		if (!isNilOrEmpty(relevantFields)) {
			sendControlNext(CLIENT_SEARCH_FORM_NAME, replaceData({ data: relevantFields }));
		}
	};
